import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // Hinweis statt Crash, damit Skeleton-Phase ohne Env funktioniert.
  // useDataState liefert dann status='error' mit klarer Message.
  // eslint-disable-next-line no-console
  console.warn(
    '[supabase] VITE_SUPABASE_URL oder VITE_SUPABASE_ANON_KEY fehlt — Datenoperationen liefern Fehler. Bitte .env.local anlegen.'
  );
}

export const supabase: SupabaseClient = createClient(url ?? '', anonKey ?? '', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});

/**
 * Tabellen-Namespace, falls V4 und V5 dieselbe Supabase-Instanz teilen.
 * Default 'v5_' kann via VITE_DB_TABLE_PREFIX überschrieben werden.
 */
export const TABLE_PREFIX: string = import.meta.env.VITE_DB_TABLE_PREFIX ?? 'v5_';

export function tableName(name: string): string {
  return `${TABLE_PREFIX}${name}`;
}
